import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'

import Dashboard from '../Dashboard'
import { selectUserRole } from '../../reducers/userDataReducer'
import { ABILITIES } from '../Can'

import DownloadApp from './DownloadApp/DownloadApp'

const ClientReservations = () => {
  const navigate = useNavigate()
  const userRole = useSelector(selectUserRole)

  useEffect(() => {
    if (!ABILITIES.Navbar.clientReservations.includes(userRole)) {
      navigate('/')
    }
  }, [userRole, navigate])

  return (
    <Dashboard.Container className="ClientReservations ctp-dashboard-building-container">
      <DownloadApp />
    </Dashboard.Container>
  )
}

export default ClientReservations
